import { yupResolver } from '@hookform/resolvers/yup'
import { TextField } from '@mui/material'
import { Button } from 'components/Button/Button'
import { useUser } from 'hooks/user'
import { useCallback, useMemo } from 'react'
import React from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { PATH, PROGRESS_TYPES } from 'utils/constants'
import getTestId from 'utils/getTestId'
import { emailSchema } from 'utils/validationSchema'
import logoAvtodor from 'images/branding/avtodor/logo.png'
import * as yup from 'yup'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import { COMPANY, CompanyName } from 'config'
import { branding } from 'utils/branding'

import styleAvtodor from '../Layout/avtodor/style.module.css'
import styleSkyeer from '../Layout/skyeer/style.module.css'

interface IFormInputs {
  email: string
}

const RestorePassword: React.FC = () => {
  const user = useUser()
  const { t } = useTranslation()

  const restoreProgress = useMemo(() => user?.state.restorePasswordProgress, [user?.state.restorePasswordProgress])
  const methods = useForm<IFormInputs>({
    resolver: yupResolver(yup.object().shape({ email: emailSchema() })),
  })

  const onSubmit: SubmitHandler<IFormInputs> = useCallback(
    data => {
      user?.actions.restorePassword(data.email)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const SigninLayout = branding.getSigninLayout()

  const style = COMPANY === CompanyName.AVTODOR ? styleAvtodor : styleSkyeer

  return (
    <SigninLayout>
      <form className={style.signinBlock} onSubmit={methods.handleSubmit(onSubmit)} autoComplete="off">
        {restoreProgress !== PROGRESS_TYPES.SUCCESS && (
          <>
            {COMPANY === CompanyName.AVTODOR ? <img src={logoAvtodor} alt="logo" className={style.logo} /> : null}
            <div className={style.enterText}>{t('restore_password.enter_email')}</div>
            <div className={style.fld}>
              <TextField
                {...methods.register('email')}
                id="email"
                name="email"
                variant="standard"
                autoComplete="username"
                placeholder={t('restore_password.email_placeholder')}
                inputProps={{
                  'data-test-id': 'email',
                }}
                aria-describedby="email-error-text"
                error={!!methods.formState.errors.email || restoreProgress === PROGRESS_TYPES.ERROR}
                fullWidth
              />
              {/* <FormHelperText id="email-error-text">Неверный формат e-mail</FormHelperText> */}
            </div>
            <Button.Standart
              dataTestId={'submit-btn'}
              disabled={restoreProgress === PROGRESS_TYPES.WORK}
              loading={restoreProgress === PROGRESS_TYPES.WORK}
              className={clsx(style.signinButton, style.restorePasswordButton)}
            >
              {t('restore_password.reset_button')}
            </Button.Standart>
          </>
        )}
        {restoreProgress === PROGRESS_TYPES.SUCCESS && (
          <>
            {COMPANY === CompanyName.AVTODOR ? <img src={logoAvtodor} alt="logo" className={style.logo} /> : null}
            <div className={style.restoreText}>{t('restore_password.success_message')}</div>
          </>
        )}
        <span data-test-id={'restore'} className={style.restoreText}>
          {t('restore_password.have_credentials')}
          <Link className={style.forgotPasswordLink} to={PATH.SIGNIN} data-test-id={getTestId('link-forgot-password')}>
            {t('restore_password.sign_in')}
          </Link>
        </span>
      </form>
    </SigninLayout>
  )
}

export default RestorePassword
